/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedResourceDtoSchema } from "./investmentNeedResourceDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedFundraisingStrategyDtoSchema = z.object({
  program: z.optional(z.string()),
  programSub: z.optional(z.string()),
  fundingAmount: z.optional(z.string()),
  fundingAmountSub: z.optional(z.string()),
  applicationStatus: z.optional(z.string()),
  targetSubmission: z.optional(z.string()),
  targetSubmissionSub: z.optional(z.string()),
  submissionMode: z.optional(z.string()),
  readinessRequirements: z.optional(z.string()),
  get resources() {
    return z.array(investmentNeedResourceDtoSchema).optional();
  },
});
